import { useEffect } from 'react';

import { clientErrorTracker } from '@spotahome/soyuz/client';

const MAPLIBRE_VERSION = 'v5.24.0';
const MAPLIBRE_SCRIPT_ID = 'maplibre-gl-script';
const MAPLIBRE_STYLESHEET_ID = 'maplibre-gl-stylesheet';
const MAPLIBRE_SCRIPT_URL = `https://unpkg.com/maplibre-gl@${MAPLIBRE_VERSION}/dist/maplibre-gl.js`;
const MAPLIBRE_STYLESHEET_URL = `https://unpkg.com/maplibre-gl@${MAPLIBRE_VERSION}/dist/maplibre-gl.css`;

const ensureStylesheet = () => {
  if (document.getElementById(MAPLIBRE_STYLESHEET_ID)) return;
  const link = document.createElement('link');
  link.id = MAPLIBRE_STYLESHEET_ID;
  link.rel = 'stylesheet';
  link.href = MAPLIBRE_STYLESHEET_URL;
  document.head.appendChild(link);
};

const loadScript = () => {
  if (window.maplibregl) return Promise.resolve();

  const existing = document.getElementById(MAPLIBRE_SCRIPT_ID);
  if (existing) {
    return new Promise((resolve, reject) => {
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', reject);
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.id = MAPLIBRE_SCRIPT_ID;
    script.src = MAPLIBRE_SCRIPT_URL;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = reject;
    document.body.appendChild(script);
  });
};

// MapLibre GL JS shares the Mapbox GL JS v1 API surface (Map, Marker, LngLat,
// LngLatBounds, NavigationControl, Source/Layer, expressions) for the methods
// the LEGACY map stack uses. The MapTiler variant runs without Mapbox GL
// loaded, so aliasing window.mapboxgl onto window.maplibregl lets the existing
// MapsAPI / Marker / clusters-api / poi-api code work unchanged.
const aliasMapboxGl = () => {
  if (!window.mapboxgl && window.maplibregl) {
    window.mapboxgl = window.maplibregl;
  }
};

export const useMaptilerScript = callback => {
  useEffect(() => {
    ensureStylesheet();
    loadScript()
      .then(() => {
        aliasMapboxGl();
        callback();
      })
      .catch(error => {
        clientErrorTracker.error({
          error,
          source: 'MapProvider-SDKLoad-Maptiler'
        });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default {
  useMaptilerScript
};
